import { useEffect, useRef, useState, useMemo } from 'react';
import './HomePage.css';
import { usePaginatedPost } from '../../../hooks/usePaginatedPost';
import ReactLoading from 'react-loading';
import { IoSearch, IoStorefrontOutline, IoCubeOutline, IoImageOutline, IoArrowUp } from "react-icons/io5";
import { IoIosClose } from "react-icons/io";
import Layout from '../../../Components/Layout/Layout';
import { Link } from 'react-router-dom';
import config from '../../../config';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import api from '../../../hooks/api';

import 'swiper/css';
import 'swiper/css/pagination';

// ---- تابع کمکی برای خواندن اطلاعات از sessionStorage ----
const getSavedState = (key, defaultValue) => {
  try {
    const saved = sessionStorage.getItem('homeSearchState');
    if (saved) {
      const parsed = JSON.parse(saved);
      return parsed[key] !== undefined ? parsed[key] : defaultValue;
    }
  } catch (e) {
    console.error("خطا در خواندن وضعیت جستجو:", e);
  }
  return defaultValue;
};

// ---- کامپوننت نمایش عکس پیش‌فرض با استفاده از React Icons ----
const FallbackImage = ({ src, alt, type }) => {
  const [hasError, setHasError] = useState(false);

  const isInvalid = !src || src.trim() === `${config.api.imageURL}/` || src.trim() === `${config.api.imageURL}/null` || src.trim() === `${config.api.imageURL}/undefined`;

  if (isInvalid || hasError) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        backgroundColor: '#f1f1f1',
        color: '#adb5bd',
        borderRadius: type === 'category' ? '50%' : 'inherit'
      }}>
        {type === 'shop' && <IoStorefrontOutline size="45px" />}
        {type === 'product' && <IoCubeOutline size="45px" />}
        {type === 'category' && <IoImageOutline size="20px" />}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      onError={() => setHasError(true)}
      style={{ width: '100%', height: '100%', objectFit: 'contain' }}
    />
  );
};

function HomePage() {
  const [categoryIdChoice, setCategoryIdChoice] = useState(() => getSavedState('categoryIdChoice', null));
  const [searchText, setSearchText] = useState(() => getSavedState('searchText', ""));
  const [localSearchText, setLocalSearchText] = useState(() => getSavedState('localSearchText', ""));
  const [tabIndexSearch, setTabIndexSearch] = useState(() => getSavedState('tabIndexSearch', 0));
  const [isSearchActive, setIsSearchActive] = useState(() => getSavedState('isSearchActive', false));

  const [cursor, setCursor] = useState(null);
  const [, setIsShopClick] = useState(false);

  // استیت و رفرنس‌های کنترل اسکرول رو به بالا
  const [showScrollTop, setShowScrollTop] = useState(false);
  const lastScrollYRef = useRef(0);
  const homePageRef = useRef(null);

  const [categories, setCategories] = useState(() => {
    try {
      const localData = localStorage.getItem("categories");
      return localData ? JSON.parse(localData) : null;
    } catch (error) {
      return null;
    }
  });

  const sentinelRef = useRef(null);

  // تابع کمکی باز کردن لینک خارجی
  const handleOpenExternalLink = (e, rawUrl) => {
    e.preventDefault();
    e.stopPropagation();

    if (!rawUrl) return;

    let targetUrl = rawUrl.trim();
    if (!targetUrl.startsWith('http://') && !targetUrl.startsWith('https://')) {
      targetUrl = `https://${targetUrl}`;
    }

    if (window.Telegram?.WebApp?.openLink) {
      window.Telegram.WebApp.openLink(targetUrl);
    } else {
      window.open(targetUrl, '_blank', 'noopener,noreferrer');
    }
  };

  useEffect(() => {
    sessionStorage.setItem('homeSearchState', JSON.stringify({
      categoryIdChoice,
      searchText,
      localSearchText,
      tabIndexSearch,
      isSearchActive
    }));
  }, [categoryIdChoice, searchText, localSearchText, tabIndexSearch, isSearchActive]);

  useEffect(() => {
    if (!categories) {
      api.post(`category/all`, { rowCount: 30 })
        .then((response) => {
          if (response.data && response.data.success) {
            const fetchedCategories = response.data.data.data;
            setCategories(fetchedCategories);
            localStorage.setItem("categories", JSON.stringify(fetchedCategories));
          }
        })
        .catch((error) => {
          console.error("خطا در دریافت دسته‌بندی‌ها:", error);
        });
    }
  }, [categories]);

  let activeSearchUrl = null;
  if (tabIndexSearch === 1) activeSearchUrl = `commodity/search`;
  if (tabIndexSearch === 2) activeSearchUrl = `business/search`;

  const searchPayload = useMemo(() => {
    return {
      search_text: searchText,
      category_id: categoryIdChoice,
      rowCount: 50
    };
  }, [searchText, categoryIdChoice]);

  const {
    data: Dataset,
    loading: isloading_search,
    isLastPage,
    nextCursor, 
    setData: setDataset
  } = usePaginatedPost(activeSearchUrl, searchPayload, cursor);

  const fn_search = () => {
    setIsSearchActive(true);
    setTabIndexSearch((prev) => (prev === 0 ? 1 : prev));
    setDataset([]);
    setCursor(null);
    setSearchText(localSearchText);
  };

  const fn_search_close = () => {
    setIsSearchActive(false);
    setDataset([]);
    setCursor(null);
    setLocalSearchText("");
    setSearchText("");
    setTabIndexSearch(0);
    setCategoryIdChoice(null);
  };

  // مانیتورینگ هوشمند اسکرول (چه در وب معمولی و چه داخل وب‌ویوی تلگرام)
  useEffect(() => {
    const handleScroll = (e) => {
      // پیدا کردن مقدار فعلی اسکرول از هر المانی که اسکرول شده
      let currentY = 0;
      if (e && e.target && e.target !== document && e.target.scrollTop !== undefined) {
        currentY = e.target.scrollTop;
      } else {
        currentY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      }

      if (homePageRef.current && homePageRef.current.scrollTop > currentY) {
        currentY = homePageRef.current.scrollTop;
      }

      const prevY = lastScrollYRef.current;

      // شرایط:
      // ۱. کاربر حداقل ۲۵۰ پیکسل از اول صفحه پایین‌تر باشد
      // ۲. در جهت رو به بالا اسکرول کند (prevY - currentY > 6)
      if (currentY > 250 && prevY - currentY > 6) {
        setShowScrollTop(true);
      } else if (currentY - prevY > 10 || currentY <= 150) {
        // اگر رو به پایین اسکرول کرد یا به بالای صفحه رسید، پنهان شود
        setShowScrollTop(false);
      }

      lastScrollYRef.current = currentY;
    };

    // فلگ true (capture) باعث می‌شود اسکرول هر دیو داخلی هم بلافاصله دیتکت شود
    window.addEventListener('scroll', handleScroll, true);

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  // اکشن کلیک: بازگشت قطعی به بالاترین نقطه بدون اسکرول دستی
  const handleScrollToTop = () => {
    if (window.Telegram?.WebApp?.HapticFeedback) {
      try {
        window.Telegram.WebApp.HapticFeedback.impactOccurred('medium');
      } catch (e) {}
    }

    // هدایت تمام کانتینرهای بالقوه به بالاترین نقطه
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
    document.body.scrollTo({ top: 0, behavior: 'smooth' });

    if (homePageRef.current) {
      homePageRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      if (homePageRef.current.parentElement) {
        homePageRef.current.parentElement.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }

    setShowScrollTop(false);
  };

  // کنترل لود صفحات بعدی با IntersectionObserver
  useEffect(() => {
    if (!isloading_search && !isLastPage && tabIndexSearch !== 0 && Dataset.length > 0 && nextCursor) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          if (window.Telegram?.WebApp?.HapticFeedback) {
            try {
              window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
            } catch (e) {}
          }
          setCursor(nextCursor);
        }
      }, {
        root: null,
        rootMargin: "0px 0px 150px 0px",
        threshold: 0.05,
      });

      const sentinelNode = sentinelRef.current;
      if (sentinelNode) observer.observe(sentinelNode);

      return () => {
        if (sentinelNode) observer.unobserve(sentinelNode);
      };
    }
  }, [isloading_search, isLastPage, tabIndexSearch, Dataset, nextCursor]);

  // منطق محاسبه قیمت و موجودی
  const getProductDisplayData = (item) => {
    const discount = parseFloat(item.discount_percent || 0);
    let variants = [];

    try {
      let parsedProps = item.properties;
      if (typeof parsedProps === 'string') {
        parsedProps = JSON.parse(parsedProps);
      }

      if (parsedProps && parsedProps.propertyData) {
        Object.values(parsedProps.propertyData).forEach(varArray => {
          if (Array.isArray(varArray)) {
            variants = variants.concat(varArray.filter(v => v.active === true || v.active === undefined));
          }
        });
      }
    } catch (e) {
      variants = [];
    }

    if (variants.length === 0) {
      variants = [{
        rawPrice: item.rawPrice || item.price,
        stock: item.stock || 0
      }];
    }

    const totalStock = variants.reduce((sum, v) => sum + (parseInt(v.stock) || 0), 0);
    const validPrices = variants.map(v => parseInt(v.rawPrice || v.price || 0)).filter(p => p > 0);
    const minPrice = validPrices.length > 0 ? Math.min(...validPrices) : 0;
    const maxPrice = validPrices.length > 0 ? Math.max(...validPrices) : 0;

    const isSinglePrice = variants.length <= 1 || minPrice === maxPrice;

    let stockBlock = null;
    if (totalStock <= 0) {
      stockBlock = (
        <span style={{ fontSize: '11px', color: '#e74c3c', marginRight: '6px', fontWeight: 'bold' }}>
          (ناموجود)
        </span>
      );
    } else if (isSinglePrice) {
      stockBlock = (
        <span style={{ fontSize: '11px', color: '#27ae60', marginRight: '6px', fontWeight: 'bold' }}>
          (موجودی: {totalStock.toLocaleString('fa-IR')})
        </span>
      );
    }

    let priceBlock = null;
    if (validPrices.length > 0) {
      if (isSinglePrice) {
        const price = minPrice;
        if (discount > 0) {
          const finalPrice = price - ((price * discount) / 100);
          priceBlock = (
            <>
              <div className="discount"><div>{Math.round(discount).toLocaleString('fa-IR')}%</div><div>تخفیف</div></div>
              <div className="price-discount">{Math.round(price).toLocaleString('fa-IR')}</div>
              <div className="commodity-price"><span>{Math.round(finalPrice).toLocaleString('fa-IR')}</span><span style={{ marginRight: "2px" }}>تومان</span></div>
            </>
          );
        } else {
          priceBlock = (
            <div className="commodity-price-orginal"><span>{Math.round(price).toLocaleString('fa-IR')}</span><span style={{ marginRight: "2px" }}>تومان</span></div>
          );
        }
      } else {
        priceBlock = (
          <>
            {discount > 0 && (
              <div className="discount"><div>{Math.round(discount).toLocaleString('fa-IR')}%</div><div>تخفیف</div></div>
            )}
            <div className="price-discount" style={{ textDecoration: 'none' }}>از {minPrice.toLocaleString('fa-IR')}</div>
            <div className="commodity-price"><span>تا {maxPrice.toLocaleString('fa-IR')}</span><span style={{ marginRight: "2px" }}>تومان</span></div>
          </>
        );
      }
    }

    return { stockBlock, priceBlock };
  };

  return (
    <>
      <Layout>
        <div className='home-page' ref={homePageRef}>
          <div className="advertisement">
            <Swiper
              modules={[Autoplay, Pagination]}
              slidesPerView={1}
              loop={true}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              pagination={{ clickable: true }}
            >
              <SwiperSlide><img src={process.env.PUBLIC_URL + "/images/ads/ad1.png"} alt="تبلیغ ۱" /></SwiperSlide>
              <SwiperSlide><img src={process.env.PUBLIC_URL + "/images/ads/ad2.png"} alt="تبلیغ ۲" /></SwiperSlide>
              <SwiperSlide><img src={process.env.PUBLIC_URL + "/images/ads/ad3.png"} alt="تبلیغ ۳" /></SwiperSlide>
            </Swiper>
          </div>

          <div className="categorys-wrraper">
            <div className="categorys">
              {!categories && <ReactLoading type={"bubbles"} color={"#5693f5"} height={40} width={50} />}
              {
                categories && categories.map((category) => (
                  <div
                    key={category.id}
                    id={category.id}
                    className={`category${categoryIdChoice === parseInt(category.id) ? " active" : ""}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      const id = parseInt(e.currentTarget.getAttribute("id"));
                      setCategoryIdChoice(prevId => (prevId === id ? null : id));
                      setCursor(null);
                      setDataset([]);
                      setIsSearchActive(true);
                      setTabIndexSearch(prevTab => (prevTab === 0 ? 2 : prevTab));
                      setSearchText(localSearchText);
                    }}
                  >
                    <div className='image'>
                      <FallbackImage
                        src={category.imagePath ? `${config.api.imageURL}/${category.imagePath}` : null}
                        alt={category.title}
                        type="category"
                      />
                    </div>
                    <div className='title'>{category.title}</div>
                  </div>
                ))
              }
            </div>
          </div>

          <div className="search">
            <div className="search-text">
              <div className="controls">
                <input
                  type='text'
                  id={"search-text"}
                  value={localSearchText}
                  placeholder='فروشگاه یا کالای مورد نظر را جستجو کنید'
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') fn_search();
                    else if (e.key === 'Escape') fn_search_close();
                  }}
                  onChange={(e) => setLocalSearchText(e.target.value)}
                />

                {(isSearchActive || localSearchText.length > 0) &&
                  <div className="search-close" onClick={fn_search_close}>
                    <IoIosClose size={"25px"} color='gray' />
                  </div>
                }

                <div className={`btn-search`} onClick={fn_search}>
                  {isloading_search && tabIndexSearch !== 0 && cursor === null ? (
                    <span className="loading-Productsearch"></span>
                  ) : (
                    <IoSearch className="btn_Productsearch" size={"22px"} color="black" />
                  )}
                </div>
              </div>
            </div>

            {(Dataset.length > 0 || isSearchActive) &&
              <div className="tab-search">
                <div className={`tab ${tabIndexSearch === 1 ? "active" : ""}`} onClick={() => {
                  if (tabIndexSearch !== 1) {
                    setIsSearchActive(true);
                    setDataset([]);
                    setCursor(null);
                    setSearchText(localSearchText);
                    setTabIndexSearch(1); 
                  }
                }}>کالا</div>
                <div className={`tab ${tabIndexSearch === 2 ? "active" : ""}`} onClick={() => {
                  if (tabIndexSearch !== 2) {
                    setIsSearchActive(true);
                    setDataset([]);
                    setCursor(null);
                    setSearchText(localSearchText);
                    setTabIndexSearch(2); 
                  }
                }} >فروشگاه</div>
              </div>
            }

            {/* لوگوی پس‌زمینه (سبد خرید) */}
            {tabIndexSearch === 0 && !isSearchActive && (
              <div className="search-watermark">
                <img src={process.env.PUBLIC_URL + "/images/sabad1.png"} alt="سبد خرید" />
              </div>
            )}

            <div className="lists">
              <div className="lists-container">

                {!isloading_search && Dataset.length === 0 && tabIndexSearch !== 0 && (
                  <div className="not-found-message">
                    {tabIndexSearch === 1 ? "کالایی با این مشخصات یافت نشد." : "فروشگاهی با این مشخصات یافت نشد."}
                  </div>
                )}

                {Dataset.length > 0 && Dataset.map((item, index) => {
                  const uniqueKey = item.id ? `${item.id}-${index}` : index;
                  const { priceBlock, stockBlock } = tabIndexSearch === 1 ? getProductDisplayData(item) : { priceBlock: null, stockBlock: null };

                  return (
                    <div key={uniqueKey}>
                      {tabIndexSearch === 1 &&
                        <Link to={`/Shop?commodityId=${item.id}`}>
                          <div className="lists-item" onClick={() => {
                            sessionStorage.setItem("store", JSON.stringify({
                              id: item.business?.id,
                              title: item.business?.title,
                              message: item.business?.message,
                            }))
                          }}>
                            <div className="item-right">
                              <FallbackImage
                                src={item.image_path ? `${config.api.imageURL}/${item.image_path.trim()}` : null}
                                alt={"کالا"}
                                type="product"
                              />
                            </div>
                            <div className="item-left">
                              <div className="business-title"><span>فروشگاه : </span><span>{item.business?.title}</span></div>
                              <div className="business-category"><span>{item.business?.category?.title}</span></div>
                              
                              <div className="commodity-title">
                                <span>{item.title}</span>
                                {stockBlock}
                              </div>
                              <div className="commodity-description"><span>{item.extraTitle ? item.extraTitle.substring(0, 70) : ""}</span></div>

                              {priceBlock}

                              {item.instagram_post_url && item.instagram_post_url.trim() !== "" && (
                                <div
                                  className="instagram-post"
                                  onClick={(e) => handleOpenExternalLink(e, item.instagram_post_url)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  <img src={process.env.PUBLIC_URL + '/images/instagram.png'} alt="insta" />
                                  <span>مشاهده در اینستاگرام</span>
                                </div>
                              )}
                            </div>
                          </div>
                        </Link>
                      }

                      {tabIndexSearch === 2 &&
                        <Link to="/Shop">
                          <div className="lists-item" onClick={() => {
                            sessionStorage.setItem("store", JSON.stringify({
                              id: item.id,
                              title: item.title,
                              message: item.message
                            }));
                            setIsShopClick(true);
                          }}>
                            <div className="item-right">
                              <FallbackImage
                                src={item.image_logo ? `${config.api.imageURL}/${item.image_logo.trim()}` : null}
                                alt={"لوگو"}
                                type="shop"
                              />
                            </div>

                            <div className="item-left">
                              <div className="business-title">
                                <span>فروشگاه : </span><span>{item.title}</span>
                              </div>

                              <div className="business-category">
                                <span>{item.category?.title}</span>
                              </div>

                              <div className="commodity-description">
                                <span>{item.message}</span>
                              </div>

                              {item.instagram_userName && item.instagram_userName.trim() !== "" && (
                                <div
                                  className="instagram"
                                  onClick={(e) => handleOpenExternalLink(e, `https://www.instagram.com/${item.instagram_userName.trim()}`)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  <img src={process.env.PUBLIC_URL + '/images/instagram.png'} alt="insta" />
                                  <span>{item.instagram_userName.trim()}</span>
                                </div>
                              )}
                            </div>
                          </div>
                        </Link>
                      }
                    </div>
                  );
                })}

                {/* اسکلتون لودینگ اولیه */}
                {isloading_search && tabIndexSearch !== 0 && Dataset.length === 0 && (
                  Array.from({ length: 4 }).map((_, index) => (
                    <div key={`skeleton-${index}`} className="lists-item skeleton-item">
                      <div className="item-right skeleton-bg"></div>
                      <div className="item-left skeleton-content">
                        <div className="skeleton-line skeleton-bg" style={{ width: '60%', height: '14px' }}></div>
                        <div className="skeleton-line skeleton-bg" style={{ width: '40%', height: '12px' }}></div>
                        <div className="skeleton-line skeleton-bg" style={{ width: '80%', height: '10px', marginTop: '5px' }}></div>
                        <div className="skeleton-line skeleton-bg" style={{ width: '30%', height: '14px', position: 'absolute', bottom: '10px', left: '10px' }}></div>
                      </div>
                    </div>
                  ))
                )}

                {/* بخش لودینگ اسکرول نامحدود */}
                <div className="loading_page" ref={sentinelRef}>
                  {isloading_search && tabIndexSearch !== 0 && Dataset.length > 0 && (
                    <div className="custom-loading-msg">
                      <div className="loading-dots">
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                      </div>
                      <span className="text">در حال دریافت موارد بیشتر...</span>
                    </div>
                  )}
                </div>

              </div>
            </div>

          </div>

          {/* آیکون شناور پرش به اول صفحه هنگام بالا آمدن کاربر */}
          <button
            type="button"
            className={`scroll-to-top-btn ${showScrollTop ? 'visible' : ''}`}
            onClick={handleScrollToTop}
            aria-label="بازگشت به بالای صفحه"
          >
            <IoArrowUp size="22px" />
          </button>

        </div>
      </Layout>
    </>
  );
}

export default HomePage;
